export default "__VITE_ASSET__DUZMDq6e__"